import { FC, useEffect } from 'react'

import { cn } from '@bem-react/classname'

import { Footer } from '@/components/Layout/Footer'
import { Header } from '@/components/Layout/Header'
import { Tag } from '@/components/UI/Tag'

import './style.scss'

const cnRefund = cn('Policy')

export const Refund: FC = (): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className={cnRefund()}>
      <Header isHome />
      <div className={cnRefund('wrapper')}>
        <p className={cnRefund('text')}>
          Please note that "Refund Policy" changed on January 31, 2025.
        </p>
        <Tag className={cnRefund('title')}>
          PLEASE CAREFULLY READ THE REFUND POLICY BEFORE USING{' '}
          <span>WWW.EXSCREAM.CC</span> WEBSITE.
        </Tag>
        <p className={cnRefund('text')}>
          EXERCIAL, s.r.o. makes every effort to provide its clients assistance
          related to the fiat funds or cryptocurrency refund process.
        </p>
        <h2 className={cnRefund('subtitle')}>1. General Conditions</h2>
        <p className={cnRefund('text')}>
          1.1. The User who has made an exchange order which included
          transaction fee, or has topped up his account may request a Refund or
          Return by the Eligibility Criteria as further set out herein.
          Refund/Return will only be considered where the user complies with the
          Eligibility Criteria in full. Where the user fails to meet any of the
          Eligibility Criteria, EXERCIAL, s.r.o. shall have the right, in its
          sole discretion, to decline the User’s request for a Refund/Return. To
          apply for a Refund/Return, the user must request and submit Refund
          information details to the EXERCIAL, s.r.o. support address -
          support@extream.cc <br />
          1.2. To prevent Prohibited Conduct, all payments and information
          related to Refund/Return may be verified by EXERCIAL, s.r.o.
          personnel. In such a case, EXERCIAL, s.r.o. may request the user to
          provide certain documents, including, but not limited to,
          identification documents, copy of the user’s Payment Card and Invoice
          or/and any other proof of the fact that the disputed payment was made.{' '}
          <br />
          In case the User fails to provide appropriate documents or information
          within two (2) days upon the EXERCIAL, s.r.o. request or in case of
          any doubts as to the authenticity of the provided documents, EXERCIAL,
          s.r.o. shall be entitled to decline the user’s Refund/Return request.
          EXERCIAL, s.r.o. endeavors to process the user’s Refund Form/Return
          Form as soon as it is reasonably practicable. We will do our best to
          ensure that within 14 days after receiving all requested documents
          according to the paragraph above your Refund Form/Return Form will be
          processed. At the same time, please note that response times will vary
          depending on stated reasons for the request. In any case, EXERCIAL,
          s.r.o. shall notify the user on the outcome of the request not later
          than within 30 days after receiving all documents requested according
          to the paragraph above. The Refund/Return request will only be
          approved or declined after meticulous verification made by EXERCIAL,
          s.r.o.. <br />
          NOTE: Submission of Refund Form/Return Form does not guarantee that
          the user`s request will be satisfied. <br />
          1.3. EXERCIAL, s.r.o. maintains full custody of cryptocurrencies, fiat
          funds, and user data/information which may be turned over to
          governmental authorities in the event of Blockchain technology Inc
          accounts’ (profiles') suspension/closure arising from fraud
          investigations, investigations of violation of law, or violation of
          the Company's policies, till the final decision will be made.
        </p>
        <h2 className={cnRefund('subtitle')}>
          2. Transactions involving a Cryptocurrency (e.g. Bitcoin)
        </h2>
        <p className={cnRefund('text')}>
          Refunds are not possible for all transactions where the user is
          purchasing a Cryptocurrency. However, in case the user changed his
          mind and would like to return the purchased Cryptocurrency, EXERCIAL,
          s.r.o. would be able to buy it back based on the current market rate
          minus the service fee for the transaction. In other words, the User
          can exchange the purchased Cryptocurrency (i.e. Bitcoin) for any
          existing Digital Currency or Payment Method (i.e. Credit Card payment
          or Bank Transfer). The reason for such a policy is the fact that the
          Cryptocurrency price changes constantly, thus the value of the
          purchased Cryptocurrency at the moment of refund will be different.
          Additionally, EXERCIAL, s.r.o. is allowed to reduce the Refunded
          amount on the exchange difference, which occurs due to the exchange or
          buyback of Cryptocurrency and corresponding crypto-exchange
          transaction fee, which accountaned from the original order
          transaction.
        </p>
        <h2 className={cnRefund('subtitle')}>
          3. Transactions that do NOT involve cryptocurrency
        </h2>
        <p className={cnRefund('text')}>
          Refunds are only possible within 14 days from the moment of exchange.
          Any additional service fees incurred by EXERCIAL, s.r.o. as a result
          of the refund will be covered by the user. For example, payment
          systems charge EXERCIAL, s.r.o. for each incoming and outgoing
          transaction. Therefore, when issuing a refund for a transaction,
          EXERCIAL, s.r.o. will send the customer an amount equal to the
          original transaction amount, minus the service fees for that
          transaction. The fees for incoming/outgoing transactions varies.
        </p>
        <h2 className={cnRefund('subtitle')}>
          4. Summary of Eligibility Criteria for Refund/Return
        </h2>
        <p className={cnRefund('text')}>
          For your convenience we gathered Eligibility Criteria stated in the
          previous paragraphs which you need to meet in order to be entitled for
          Refund/Return:
        </p>
        <ul className={cnRefund('list')}>
          <li className={cnRefund('item')}>
            Refund/Return must be submitted not later than within 14 days days
            from the moment of exchange;
          </li>
          <li className={cnRefund('item')}>
            You need to provide in full all documents requested by the EXERCIAL,
            s.r.o. needed to verify information related to Refund/Return;
          </li>
          <li className={cnRefund('item')}>
            Only requests for Refund/Return sent to support@exstream.cc will be
            processed;
          </li>
          <li className={cnRefund('item')}>
            Your funds are not held by us due to the order produced by any
            governmental authority.
          </li>
        </ul>
        <h2 className={cnRefund('subtitle')}>5. Chargebacks</h2>
        <p className={cnRefund('text')}>
          EXERCIAL, s.r.o. provides its clients with the possibility to resolve
          any problem or issue related to exchanges before the client fills a
          complaint request (chargeback) with the customers’ bank. The
          settlement process takes place by contacting the customer support
          department. <br />
          EXERCIAL, s.r.o. reserves the right to suspend the client’s account
          during the complaint request investigation process.
        </p>
        <h2 className={cnRefund('subtitle')}>6. Miscellaneous.</h2>
        <p className={cnRefund('text')}>
          Any charges, which arise upon processing Refund/Return, shall be borne
          solely by the user. Such charges will be deducted from the final
          amount of the Refund/Return. This Refund Policy will be amended from
          time to time if there is any change in the legislation. Terms and
          conditions of the Refund Policy are subject to change by EXERCIAL,
          s.r.o.. In case the user fails to complete necessary compliance
          AML/KYC procedures, EXERCIAL, s.r.o. is allowed to return initial
          transaction and charge the commission to cover transaction costs. In
          case the user does not wish to accept the revised Refund Policy,
          he/she should not continue to use EXERCIAL, s.r.o. Services. If the
          User continues to use the Services after the date on which the change
          comes into effect, his/her use of the Services is to be bound by the
          new Refund Policy. <br />
          We support spread-only pricing model. The spread is the difference
          between the buy and sell prices quoted for a cryptocurrency. Our fees
          are wrapped into the spread and exchange rate contains the fees.
          Changes to the Fee are effective as of the effective date indicated in
          the Terms updates.
        </p>
        <h2 className={cnRefund('subtitle')}>7. The refund fee</h2>
        <p className={cnRefund('text')}>
          MasterCard <br />
          Processing fee: 4.5% <br />
          Service fee: 4.5% <br />
          SEPA <br />
          Processing fee: 0% <br />
          Service fee: 5% <br />
          Commission related to the cryptocurrency return processing depends on
          the type of cryptocurrency, rate changes, network commission, etc.{' '}
          <br />
          Please note that the cryptocurrency rate can change very dynamically,
          therefore, there may be a negative difference between the value of the
          cryptocurrency at the time of purchase and its value at the time of
          sale; this difference is covered by the refund amount. <br />
          EXERCIAL, s.r.o. reserves the right to make changes and amendments to
          this Refund Policy, including if any changes are made to the law. If
          the client does not agree with the possible changes, he/she should
          stop using the EXERCIAL, s.r.o. service.
        </p>
      </div>
      <Footer isHome />
    </div>
  )
}
